export default __webpack_public_path__ + "static/media/downloads.9baa8eca.svg";